import React from 'react'
import Table from './TablePagination'
import Header from './Header/Header'
import { BigTableData } from '../../data/bigTableData'
import styled from 'styled-components'

const styles = {
  searchBarStyles: {
    top: '-22px',
  },
  tablesStyles: {
    marginTop: '-22px',
  },
}

const Wrapper = styled.div`
  padding-left: 64px;
  width: 100%;
`

const Incidents: React.FC = () => {
  const actions = ['Foo', 'Bar']

  const handleOnAction = (action, rowId) => {
    switch (action) {
      case 'Foo':
        console.log('Action: Foo', 'rowId:', rowId)
        break
      case 'Bar':
        console.log('Action: Bar', 'rowId:', rowId)
        break
    }
  }

  const handleOnFilter = (filter) => {
    console.log('handleOnFilter', filter)
  }

  return (
    <>
      <Header />
      <Wrapper>
        <Table
          onFilter={handleOnFilter}
          actions={actions}
          onAction={handleOnAction}
          isExpandable
          styles={styles}
          data={BigTableData()}
        />
      </Wrapper>
    </>
  )
}

export default Incidents
